const data = {
    English:{
        welcomeTo: "Welcome to",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "Scan my location",
        directions: "Directions",
        language: "Language",
        announcements: "Announcements",
        doNotShowOneDay: "Do not show for one day",
        positionQR: "Position the QR code below",
        manualEntry: "Manual entry",
        enter: "Enter",
        back: "Back",
        enterYour: "Enter your current location",
        youAreAt: "You are at",
        whereTo: "Where to?",
        enterDestination: "Enter destination",
        currentLocation: "Current Location",
        destination: "Destination",
        home: "Home",
        takeElevator: "Take elevator to",
        next: "Next",
    },

    Français:{
        welcomeTo: "Bienvenue à",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "Scanner ma position",
        directions: "Directions",
        language: "Langue",
        announcements: "Annonces",
        doNotShowOneDay: "Ne pas montrer pour un jour",
        positionQR: "Positionner le code qr ci-dessous",
        manualEntry: "Enscription manuel",
        enter: "Entrer",
        back: "Retourner",
        enterYour: "Entrez votre emplacement actuel",
        youAreAt: "Tu es a",
        whereTo: "Où aller?",
        enterDestination: "Entrez la destination",
        currentLocation: "Localisation actuelle",
        destination: "Destination",
        home: "Accueil",
        takeElevator: "Ascenseur - ",
        next: "Suivante",
    },

    Español:{
        welcomeTo: "Bienvenido a",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "Escanear mi ubicacion",
        directions: "Direcciones",
        language: "Idiomas",
        announcements: "Anuncios",
        doNotShowOneDay: "No mostrar por un día",
        positionQR: "Posicione el código qr abajo",
        manualEntry: "Entrada manual",
        enter: "Entrar",
        back: "Atrás",
        enterYour: "Ingresa tu ubicación acutal",
        youAreAt: "Estás en",
        whereTo: "¿A donde?",
        enterDestination: "Entrar destino",
        currentLocation: "Ubicación acutal",
        destination: "Destino",
        home: "Inicio",
        takeElevator: "Ascensor - ",
        next: "Siguiente",
    },

    Deutsche: {
        welcomeTo: "Willkommen zu",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "Standort-Scan",
        directions: "Richtungen",
        language: "Sprachen",
        announcements: "Ankündigungen",
        doNotShowOneDay: "Zeigen Sie dies nicht für einen Tag",
        positionQR: "Positionieren Sie den QR-Code unten",
        manualEntry: "manueller Eintrag",
        enter: "Eingeben",
        back: "Zurück",
        enterYour: "Geben Sie Ihren Standort ein",
        youAreAt: "Du bist am",
        whereTo: "Wo hin?",
        enterDestination: "Ziel eingeben",
        currentLocation: "Aktueller Standort",
        destination: "Ziel",
        home: "Beginn",
        takeElevator: "Aufzug - ",
        next: "Nächster",
    },

    Português: {
        welcomeTo: "Bem-vindo ao",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "Scan my location",
        directions: "Instruções",
        language: "Língua",
        announcements: "Anúncios",
        doNotShowOneDay: "Não mostrar por um dia",
        positionQR: "Posicione o código QR abaixo",
        manualEntry: "Entrada manual",
        enter: "Entrar",
        back: "Retorna",
        enterYour: "Digite sua localização atual",
        youAreAt: "Você está em",
        whereTo: "Para onde?",
        enterDestination: "Digite o destino",
        currentLocation: "Localização atual",
        destination: "Destino",
        home: "Pagina inicial",
        takeElevator: "Elevador - ",
        next: "Segue",
    },

    ਪੰਜਾਬੀ: {
        welcomeTo: "ਸਵਾਗਤ ਹੈ",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "ਮੇਰੇ ਸਥਾਨ ਤੇ ਸਕੈਨ ਕਰੋ",
        directions: "ਦਿਸ਼ਾਵਾਂ",
        language: "ਭਾਸ਼ਾ",
        announcements: "ਘੋਸ਼ਣਾਵਾਂ",
        doNotShowOneDay: "ਇੱਕ ਦਿਨ ਲਈ ਨਾ ਦਿਖਾਓ",
        positionQR: "ਸਥਿਤੀ QR ਕੋਡ ਹੇਠਾਂ",
        manualEntry: "ਦਸਤੀ ਇੰਦਰਾਜ਼",
        enter: "ਦਿਓ",
        back: "ਵਾਪਸ ਜਾਓ",
        enterYour: "ਆਪਣੇ ਮੌਜੂਦਾ ਸਥਾਨ ਦਾਖਲ ਕਰੋ",
        youAreAt: "ਤੁਸੀਂ ਇੱਥੇ ਹੋ",
        whereTo: "ਕਿਧਰ ਨੂੰ?",
        enterDestination: "ਮੰਜ਼ਿਲ ਦਾਖ਼ਲ ਕਰੋ",
        currentLocation: "ਮੌਜੂਦਾ ਸਥਿਤੀ",
        destination: "ਮੰਜ਼ਲ",
        home: "ਪਹਿਲਾ ਪੰਨਾ",
        takeElevator: "ਐਲੀਵੇਟਰ - ",
        next: "ਅਗਲਾ",
    },

    中文:{
        welcomeTo: "欢迎来到",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "扫描我的位置",
        directions: "路线",
        language: "语言",
        announcements: "公告",
        doNotShowOneDay: "一天不显示",
        positionQR: "扫描二维码",
        manualEntry: "手动输入",
        enter: "输入",
        back: "返回",
        enterYour: "输入你的位置",
        youAreAt: "你的位置是",
        whereTo: "目的地:",
        enterDestination: "输入目的地",
        currentLocation: "当前位置",
        destination: "目的地",
        home: "首页",
        takeElevator: "电梯 - ",
        next: "下一个",
    },

    한국어:{
        welcomeTo: "환영합니다",
        rch: "Royal Columbian Hospital",
        scanMyLocation: "스캔하여 내 위치 검색",
        directions: "찾아가는길",
        language: "언어",
        announcements: "공지사항",
        doNotShowOneDay: "하루동안 보지 않기",
        positionQR: "아래에 QR를 스캔하세요",
        manualEntry: "직접 입력하기",
        enter: "입력",
        back: "뒤로",
        enterYour: "현재 위치를 입력하여 주세요",
        youAreAt: "현재 위치는",
        whereTo: "목적지:",
        enterDestination: "목적지를 입력하여 주세요",
        currentLocation: "현위치",
        destination: "목적지",
        home: "홈으로",
        takeElevator: "다음층으로 이동하세요",
        next: "다음",
    }
}
export {data};